export const generateFingerprint = async (): Promise<string> => {
  const { v4: uuidv4 } = await import('uuid');
  return uuidv4();
};
